/**
 * Used to allow functions/classes to indicate that they should be registered as transients with the container.
 */
var TransientRegistration = /** @class */ (function () {
    /**
     * Creates an instance of TransientRegistration.
     * @param key The key to register as.
     */
    function TransientRegistration(_key) {
        this._key = _key;
    }
    /**
     * Called by the container to register the resolver.
     * @param container The container the resolver is being registered with.
     * @param key The key the resolver should be registered as.
     * @param fn The function to create the resolver for.
     * @return The resolver that was registered.
     */
    TransientRegistration.prototype.registerResolver = function (container, key, fn) {
        var existingResolver = container.getResolver(this._key || key, false);
        return existingResolver === undefined
            ? container.registerTransient(this._key || key, fn)
            : existingResolver;
    };
    return TransientRegistration;
}());
export { TransientRegistration };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVHJhbnNpZW50UmVnaXN0cmF0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiVHJhbnNpZW50UmVnaXN0cmF0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVNBOztHQUVHO0FBQ0g7SUFDSTs7O09BR0c7SUFDSCwrQkFBb0MsSUFBYTtRQUFiLFNBQUksR0FBSixJQUFJLENBQVM7SUFBRyxDQUFDO0lBRXJEOzs7Ozs7T0FNRztJQUNJLGdEQUFnQixHQUF2QixVQUF3QixTQUFvQixFQUFFLEdBQVcsRUFBRSxFQUFlO1FBQ3RFLElBQU0sZ0JBQWdCLEdBQUcsU0FBUyxDQUFDLFdBQVcsQ0FBQyxJQUFJLENBQUMsSUFBSSxJQUFJLEdBQUcsRUFBRSxLQUFLLENBQUMsQ0FBQztRQUV4RSxPQUFPLGdCQUFnQixLQUFLLFNBQVM7WUFDakMsQ0FBQyxDQUFDLFNBQVMsQ0FBQyxpQkFBaUIsQ0FBQyxJQUFJLENBQUMsSUFBSSxJQUFJLEdBQUcsRUFBRSxFQUFFLENBQUM7WUFDbkQsQ0FBQyxDQUFDLGdCQUFnQixDQUFDO0lBQzNCLENBQUM7SUFDTCw0QkFBQztBQUFELENBQUMsQUFyQkQsSUFxQkMifQ==